import initialState from "./initialState";
import {API_CALL_STARTED} from "../actions/ApiCallsActions";
import {SET_LOADING} from "../LoadingActions";

/**
 *
 * The reducer handling setting flags for API call that are in progress.
 * credit for this solution can be found @
 * https://medium.com/stashaway-engineering/react-redux-tips-better-way-to-handle-loading-flags-in-your-reducers-afda42a804c6
 *
 * eg '[Contract] API_CALL_STARTED' action type would update this store
 * '[Contract]' parameter value to true which signifies a contract request is being made.
 * A
 * With this our ui can react to relevant api requests.
 */
export default (state = initialState.loading, action) => {
    const {type} = action;

    // for case that the state is being updated directly.
    if (type === SET_LOADING) {
        const {requestName, requestState} = action.payload.data;
        return {
            ...state,
            [requestName]: requestState
        };
    }

    // catch all API_CALL_STARTED, API_CALL_SUCCESS and API_CALL_SUCCESS actions
    const matches = /(.*) (API_CALL_STARTED|API_CALL_SUCCESS|API_CALL_ERROR)/.exec(type);

    // not api request so we return state.
    if (!matches) return state;

    const [, requestName, requestState] = matches;

    return {
        ...state,
        // Store whether a request is happening at the moment or not
        // e.g. will be true when receiving '[contracts] API_CALL_STARTED'
        //      and false when receiving '[contracts] API_CALL_SUCCESS' / '[contracts] API_CALL_ERROR'
        [requestName] : requestState === API_CALL_STARTED
    };
}
